import {
  Button,
  Empty,
  Input,
  List,
  message,
  message as toast,
  Modal,
  Select,
  Tooltip
} from "antd";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { connect } from "dvajs";
import { useTranslation } from "react-i18next";
import { EbookState } from "@/models/ebook";
import { getExtManager, getMyAdministratorsList } from "@/api/ebook";
import "./index.less";
import { ListItem } from "@jd/focus-desktop-comps";
import { openUserCardModal } from "@/components/AddressBook/common";
import { getDeptPositionDesc } from "@/models/user";
import ChatState from "@/types/chat/State";
import { Employee } from "@/types/chat";
import { ListItemData } from "@/components/ListItem";
import { debounce, uniqBy } from "lodash";
import IconFont from "@/components/icon";
import { changeEgovUrl } from "@/utils/tools";
import config, { ConfigEnum } from "@/config/config";
import { QuestionCircleOutlined } from "@/utils/antdIcon";
import ImService from "@/server/ImService";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { UserCardType } from "@jd/focus-desktop-comps/lib/es/UserCard/UserCardType";
import useCustomUserCardModal from "../useCustomUserCardModal";
import { analysisLog } from "@/utils/logAnalytics";
const { Option } = Select;

function AdministratorModal({
  visible,
  onCancel,
  type,
  openCreateContactModal,
  cardType
}: {
  visible: boolean;
  onCancel: () => void;
  type: string; // unitAdministrator单位管理员  Administrator管理者
  openCreateContactModal: Function;
  cardType?: UserCardType;
}) {
  const { authInfo } = useContext<GlobalContextConfig>(GlobalContext);
  const [t] = useTranslation("chat");
  const [administratorList, setAdministratorList] = useState<ListItemData[]>([]);
  const [loading, setLoading] = useState(false);
  const [currentEmployeeData, setCurrentEmployeeData] = useState<any>({});
  const [value, setValue] = useState("");
  const handleCancel = useCallback(() => {
    onCancel();
    setAdministratorList([]);
  }, [onCancel]);

  const getCurrentData = useCallback(async () => {
    const imService = ImService.getInstance();
    const user: any = await imService.getCurrentEmployee();
    setCurrentEmployeeData(user || {});
    setValue(user?.partTimeTitleDeptInfo?.[0]?.deptId || user?.deptId);
  }, []);

  useEffect(() => {
    getCurrentData();
  }, [getCurrentData]);

  const getResData = useCallback(async () => {
    if (type === "unitAdministrator") {
      return await getMyAdministratorsList({
        deptId: value
      });
    } else {
      return await getExtManager();
    }
  }, [type, value]);

  const handleSearch = useCallback(async () => {
    setLoading(true);
    const [result, err] = await getResData();
    setLoading(false);
    const data =
      type === "unitAdministrator" ? result?.myAdministratorList : [result?.extManagerInfo];

    if (err || !data.length) {
      setAdministratorList([]);
      if (type === "unitAdministrator" && currentEmployeeData?.partTimeTitleDeptInfo.length === 1) {
        message.warning("单位暂无管理员");
        handleCancel();
      }
      return;
    }

    setAdministratorList(
      data.map((item: any) => {
        return {
          ...item,
          id: `${item.userId}:${item.appId}:${item.teamId}`,
          name: item?.realName,
          avatar: item?.headImg,
          desc: getDeptPositionDesc({
            deptName: item?.deptName || "",
            titleName: item?.titleName || "",
            unitName: item?.unitName || "",
            userType: item?.userType
          }),
          labelInfoList: item?.labelInfoList || [],
          app: item?.appId,
          teamId: item?.teamId,
          userId: item?.userId,
          remark: item?.remark
        };
      })
    );
  }, [currentEmployeeData, getResData, handleCancel, type]);

  // const handleSearch = debounce(getDataList, 200);

  useEffect(() => {
    if (
      ((!currentEmployeeData?.partTimeTitleDeptInfo || !value) && type === "unitAdministrator") ||
      !visible
    ) {
      return;
    }
    handleSearch();
  }, [currentEmployeeData, handleSearch, type, value, visible]);

  const getExtraPart = (item: ListItemData) => {
    return <IconFont type="iconapp_ic_arrow_right" />;
  };

  const TooltipTitle = useCallback(() => {
    return <div className="Tooltip-title">邀请人默认成为您的管理者，后续可由管理员调整</div>;
  }, []);

  function handleChange(value: any) {
    setValue(value);
  }

  const { openCustomUserCardModal } = useCustomUserCardModal({
    openCreateContactModal,
    userData: authInfo,
    currentEmployee: currentEmployeeData
  });

  if (
    !currentEmployeeData?.partTimeTitleDeptInfo ||
    (type === "unitAdministrator" &&
      currentEmployeeData?.partTimeTitleDeptInfo?.length === 1 &&
      administratorList.length === 0)
  ) {
    return null;
  }

  const deptList: any = uniqBy(currentEmployeeData?.partTimeTitleDeptInfo, "unitDeptId");

  return (
    <Modal
      destroyOnClose
      maskClosable
      title={
        type === "unitAdministrator" ? (
          "请选择单位管理员"
        ) : (
          <div>
            请选择管理者
            <Tooltip placement="top" title={TooltipTitle}>
              <span style={{ marginLeft: "6px", fontSize: "12px" }}>
                <QuestionCircleOutlined />
              </span>
            </Tooltip>
          </div>
        )
      }
      visible={visible}
      footer={null}
      onCancel={() => {
        handleCancel();
      }}
      width="480px"
      wrapClassName="administratorModal"
      bodyStyle={{
        padding: "10px 0"
      }}
      centered={true}
    >
      {type === "unitAdministrator" && currentEmployeeData.userType !== "1" && (
        <div className="unitName">
          单位名称：
          {deptList.length > 1 ? (
            <Select onChange={handleChange} value={value} style={{ width: 320 }}>
              {deptList.map((el: any) => {
                return (
                  <Option className="mobileInputOption" value={el?.deptId} key={el?.deptId}>
                    {el?.unitName}
                  </Option>
                );
              })}
            </Select>
          ) : (
            deptList?.[0]?.unitName
          )}
        </div>
      )}
      <div className="list">
        <List
          loading={loading}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={type === "unitAdministrator" ? "单位暂无管理员" : "暂无管理者"}
              />
            )
          }}
          dataSource={administratorList || []}
          renderItem={(item: any) => {
            let { avatar } = item;
            item.avatar = changeEgovUrl(avatar);
            return (
              <ListItem
                data={item}
                itemShowRemark
                onClick={debounce((item: ListItemData) => {
                  // openUserCardModal(item);
                  if (cardType === UserCardType.CustomUser) {
                    const option = {
                      ...item,
                      appId: item?.app,
                      userId: item?.userId,
                      teamId: item?.teamId,
                      type: UserCardType.CustomUser
                    };
                    openCustomUserCardModal({
                      data: option,
                      currentUserData: {
                        teamId: currentEmployeeData.teamId || authInfo.teamUserInfo.teamId,
                        appId: currentEmployeeData.app || authInfo.ddAppId,
                        userId: currentEmployeeData.userId || authInfo.userId,
                        unitName: currentEmployeeData.unitName,
                        name: currentEmployeeData.name
                      }
                    });
                  } else {
                    openUserCardModal(item);
                  }
                  if (type === "unitAdministrator") {
                    analysisLog("xtbg_add_home_1637657110163", "77");
                  } else {
                    analysisLog("xtbg_add_home_1637657110163", "76");
                  }

                  handleCancel();
                }, 500)}
                extra={getExtraPart(item)}
              />
            );
          }}
        />
      </div>
    </Modal>
  );
}
function mapStateToProps({ ebook, chat, user }: { ebook: EbookState; chat: ChatState; user: any }) {
  return {
    // currentEmployee: chat.currentEmployee || {}
  };
}
function mapDispatchToProps(dispatch: any) {
  return {
    openCreateContactModal(data: any) {
      dispatch({ type: "ebook/openCreateContactModal", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdministratorModal);
